import { useUISize } from 'app/utils/web-helpers';
import { IntroScreen as IntroScreenSmall } from './intro.small';
import { IntroScreen as IntroScreenLarge } from './intro.large';

export const IntroScreen: typeof IntroScreenSmall = (props) => {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <IntroScreenSmall {...props} />;
  }
  return <IntroScreenLarge {...props} />;
};
